import styled from "styled-components"

import { type UserCoursePageInput, type PersonalizedCourse } from "@forento/shared/models/course"

import CourseComments from "~/themes/school/components/CourseComments"
import Resources from "~/themes/school/components/Resources"
import { lightTextColor } from "~/themes/school/styles"
import { useTranslation } from "~/translations"

import ChaptersList from "./ChaptersList"
import Inputs from "./Inputs"

export default function useTabs(
	course: PersonalizedCourse,
	inputs: UserCoursePageInput[],
	reloadCourse: () => Promise<unknown>,
) {
	const t = useTranslation()

	const tabs = []
	if (course.presentationHtml !== null) {
		tabs.push({
			title: t("course.overview"),
			content: (
				<AboutContent>
					<div className="editorjs" dangerouslySetInnerHTML={{ __html: course.presentationHtml }} />
				</AboutContent>
			),
		})
	}
	tabs.push({
		title: t("course.chapters"),
		content: (
			<ChaptersList
				chapters={course.chapters}
				firstUncompletedPageId={
					course.status === "unlocked" ? (course.firstUncompletedPage?.id ?? null) : undefined
				}
			/>
		),
	})
	if (course.status === "unlocked" && course.resources.length > 0) {
		tabs.push({
			title: t("course.resources"),
			content: <Resources resources={course.resources} />,
		})
	}
	if (course.commentsEnabled) {
		tabs.push({
			title: t("course.comments"),
			content: (
				<CourseComments
					courseId={course.id}
					pageId={null}
					commentsUnderReview={course.status === "unlocked" ? course.commentsUnderReview : 0}
					reloadCourse={reloadCourse}
				/>
			),
		})
	}
	if (inputs.length > 0) {
		tabs.push({
			title: t("course.inputs"),
			content: <Inputs inputs={inputs} />,
		})
	}
	return tabs
}

const AboutContent = styled.div`
	h1,
	h2 {
		font-weight: 600;
		font-size: 20px;
		color: #151d48;
	}
	h3,
	h4,
	h5,
	h6 {
		font-weight: 600;
		font-size: 18px;
		color: #151d48;
	}

	p {
		font-size: 16px;
		color: ${lightTextColor};
	}
`
